import { DropFunction, useDragDrop } from './draggable';
import { DragItemType } from './dragItemTypes';

export function useJobCostItemDragDrop({ item, handleDrop }: { item: Record<string, any> | (() => Record<string, any>), handleDrop?: DropFunction}) {
	const { key, type, sortIndex } = (typeof item === 'function'? item(): item);
	const [{isDragging, dragSourceRef, dragPreviewRef, dropItem, dropTargetRef}] = useDragDrop({ 
		type: DragItemType.JOBCOST_LINEITEM,
		dragItem: { key, type, sortIndex },
		canDrop: (dragItem, dropItem) => dragItem.key !== dropItem.key && dragItem.type === dropItem.type,
		handleDrop
	});
	const rowRef = el => {
		if(dropTargetRef) {
			dropTargetRef(el);
		}
		if(dragPreviewRef) {
			dragPreviewRef(el);
		}
	}

	return [{isDragging, dragSourceRef, dragPreviewRef, dropItem, dropTargetRef, rowRef}];
}